const expandBtns = document.querySelectorAll(".expand-button");
if (expandBtns.length) {
  expandBtns.forEach((link) => {
    link.addEventListener("click", (e) => {
      const content = document.querySelector(link.getAttribute("href"));
      if (content) {
        content.classList.toggle("is-expanded");
        if (content.classList.contains("is-expanded")) link.innerHTML = link.dataset.textexp
        else link.innerHTML = link.dataset.text
      }
    });
  });
}

if (window.location.hash) {
  const btn = document.querySelector('a[href="'+window.location.hash+'"]')
  if (btn) btn.click()
}